<!-- Header-->
<app-header id="top"></app-header>

<!-- Page content-->
<!-- Hero + reserva frame-->
<section class="hero-section bg-top-center bg-repeat-0 pt-5">
  <div class="container pt-5">
    <app-hero-carousel></app-hero-carousel>
  </div>
  @if(showTercerizacaoGrowingSection){
  <section class="container pt-4 pb-5 mb-md-4 tercerizacao-growing-section">
    @if (beneficioAlerta?.visivel) {
    <div class="tercerizacao-tributaria-notice mb-4">
      <div class="d-flex flex-column flex-lg-row align-items-lg-center gap-3 text-light">
        <div class="d-flex align-items-start gap-3">
          <i class="pi pi-exclamation-triangle tercerizacao-tributaria-notice__icon flex-shrink-0" aria-hidden="true"></i>
          <p class="mb-0 tercerizacao-tributaria-notice__text">{{ beneficioAlerta?.texto }}</p>
        </div>
        @if (beneficioLinkInterno(beneficioAlerta?.botao_link)) {
          <a class="btn btn-primary tercerizacao-tributaria-notice__cta flex-shrink-0" [routerLink]="locale.localizePath(beneficioAlerta?.botao_link || '/')">{{ beneficioAlerta?.botao_texto }}</a>
        } @else {
          <a class="btn btn-primary tercerizacao-tributaria-notice__cta flex-shrink-0" [href]="beneficioAlerta?.botao_link">{{ beneficioAlerta?.botao_texto }}</a>
        }
      </div>
    </div>
    }
    <h2 class="mb-4 pb-2 text-light text-start">{{ beneficioSecaoTitulo || (homeTipoLocacao === 'assinatura' ? ('home.porQueAssinar' | transloco) : ('home.porQueTercerizar' | transloco)) }}</h2>
    <div class="tns-carousel-wrapper tns-nav-outside tns-carousel-light">
      <div class="row row-cols-lg-3 row-cols-md-2 row-cols-1 g-4 mx-0 py-3">
        @for(card of beneficioCards; track card.id){
        <div class="col">
          <div class="card card-light card-hover h-100">
            <div class="card-body icon-box text-start">
              <div class="icon-box-media bg-dark text-light mx-auto mb-3 d-inline-flex align-items-center justify-content-center">
                <img [src]="cardImagem(card.imagem_path)" class="icon-full" [alt]="card.titulo">
              </div>
              <h4 class="card-title">{{ card.titulo }}</h4>
              <p class="card-text fs-sm opacity-70">{{ card.texto }}</p>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </section>
  }
  @if(showVehicleSearch){
  <div class="container mt-4 mt-sm-3 mt-lg-3 pb-5 mb-md-4">
    <app-vehicle-search variant="seminovos"></app-vehicle-search>
  </div>
  }
  @if(showTercerizacaoVehicleSearch){
  <div class="container mt-4 mt-sm-3 mt-lg-n3 pb-5 mb-md-4">
    <app-vehicle-search [variant]="homeTipoLocacao === 'assinatura' ? 'assinatura' : 'tercerizacao'"></app-vehicle-search>
  </div>
  }
</section>

@if(showReservationFrame && !showTercerizacaoGrowingSection){
<section class="reservation-section">
  <div class="container pt-4 pb-5 mb-md-4" id="reservar">
    @if(useEasyReservationEmulator){
      <form ngNoForm class="reservation-emulator" method="post" [action]="easyReservationAction" autocomplete="off" (submit)="prepareReservationSubmit($event)">
        <input type="hidden" name="COD_SISTEMA" value="502">
        <input type="hidden" name="frame2" value="1">
        <input type="hidden" name="A083_mn_locacao" value="00">
        <input type="hidden" name="A083_mn_retorno" value="00">
        <input type="hidden" name="A083_dt_locacao" [value]="pickupDateBr">
        <input type="hidden" name="A083_dt_retorno" [value]="returnDateBr">

        <div class="row g-2 align-items-end">
          <div class="col-12 col-lg-3">
            <label class="form-label text-light" for="easy-pickup-location">{{ 'home.pickup' | transloco }}</label>
            <select class="form-select form-select-light" id="easy-pickup-location" name="A011_cd_empresa" [(ngModel)]="reservationForm.pickupLocation" [ngModelOptions]="{ standalone: true }">
              @for(location of reservationLocations; track location.value){
                <option [value]="location.value">{{ location.label }}</option>
              }
            </select>
          </div>
          <div class="col-7 col-sm-8 col-lg-2">
            <label class="form-label text-light" for="easy-pickup-date">{{ 'home.date' | transloco }}</label>
            <input class="form-control form-control-light" id="easy-pickup-date" type="date" [min]="minReservationDateIso" name="pickupDateIso" [(ngModel)]="reservationForm.pickupDateIso" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onPickupChanged()">
          </div>
          <div class="col-5 col-sm-4 col-lg-1">
            <label class="form-label text-light" for="easy-pickup-hour">{{ 'home.time' | transloco }}</label>
            <select class="form-select form-select-light reservation-hour-select" id="easy-pickup-hour" name="A083_hr_locacao" [(ngModel)]="reservationForm.pickupHour" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onPickupChanged()">
              @for(hour of reservationHours; track hour.value){
                <option [value]="hour.value">{{ hour.label }}</option>
              }
            </select>
          </div>
          <div class="col-12 col-lg-3">
            <label class="form-label text-light" for="easy-return-location">{{ 'home.dropoff' | transloco }}</label>
            <select class="form-select form-select-light" id="easy-return-location" name="A011_cd_empresa_devolucao" [(ngModel)]="reservationForm.returnLocation" [ngModelOptions]="{ standalone: true }">
              @for(location of reservationLocations; track location.value){
                <option [value]="location.value">{{ location.label }}</option>
              }
            </select>
          </div>
          <div class="col-7 col-sm-8 col-lg-2">
            <label class="form-label text-light" for="easy-return-date">{{ 'home.date' | transloco }}</label>
            <input class="form-control form-control-light" id="easy-return-date" type="date" [min]="minReturnDateIso" name="returnDateIso" [(ngModel)]="reservationForm.returnDateIso" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onReturnChanged()">
          </div>
          <div class="col-5 col-sm-4 col-lg-1">
            <label class="form-label text-light" for="easy-return-hour">{{ 'home.time' | transloco }}</label>
            <select class="form-select form-select-light reservation-hour-select" id="easy-return-hour" name="A083_hr_retorno" [(ngModel)]="reservationForm.returnHour" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onReturnChanged()">
              @for(hour of reservationHours; track hour.value){
                <option [value]="hour.value">{{ hour.label }}</option>
              }
            </select>
          </div>
          <div class="col-12">
            <button class="btn btn-primary w-100" type="submit" [disabled]="reservationChecking">
              {{ reservationChecking ? ('home.validating' | transloco) : ('home.continueReservation' | transloco) }}
            </button>
          </div>
          @if(reservationValidationMessage){
            <div class="col-12">
              <p class="reservation-message mb-0">{{ reservationMessageKey ? (reservationMessageKey | transloco) : reservationValidationMessage }}</p>
            </div>
          }
        </div>
      </form>

    } @else {
      <div class="reservation-frame">
        <iframe src="https://reserva.easycarros.com/index2.asp?COD_SISTEMA=502" [title]="'home.reservationTitle' | transloco" scrolling="no" referrerpolicy="strict-origin-when-cross-origin"></iframe>
      </div>
    }
    <div class="reservation-requirements">
      <h3>{{ 'home.requirements' | transloco }}</h3>
      <ul>
        <li>
          <i class="fi-user-check" aria-hidden="true"></i>
          <span>{{ 'home.minAge' | transloco }}</span>
        </li>
        <li>
          <i class="fi-calendar-alt" aria-hidden="true"></i>
          <span>{{ 'home.license' | transloco }}</span>
        </li>
        <li>
          <i class="fi-credit-card" aria-hidden="true"></i>
          <span>{{ 'home.card' | transloco }}</span>
        </li>
      </ul>
    </div>
    <div class="reservation-support-actions">
      <a class="btn btn-outline-light btn-sm" [routerLink]="locale.localizePath('/pages/help-center')">
        <i class="fi-help me-2" aria-hidden="true"></i>{{ 'footer.ajuda' | transloco }}
      </a>
      <a class="btn btn-outline-light btn-sm" [routerLink]="locale.localizePath('/pages/contacts')">
        <i class="fi-chat-left me-2" aria-hidden="true"></i>{{ 'menu.contato' | transloco }}
      </a>
    </div>
  </div>
</section>
}


<!-- Recursos-->
<section class="container pt-4 pt-md-5 home-differentiators-section">
  <h2 class="h3 text-light mb-2 mb-sm-0">{{ 'home.differentiators' | transloco }}</h2>
  <div class="row">
    <div class="col-md-5 col-lg-4 offset-lg-1 pt-4 mt-2 pt-md-5 mt-md-3">
      <div class="d-flex pb-4 pb-md-5 mb-2"><i class="fi-file lead text-primary mt-1 order-md-2"></i>
        <div class="text-md-end ps-3 ps-md-0 pe-md-3 order-md-1">
          <h3 class="h6 text-light mb-1">{{ 'home.diff1Title' | transloco }}</h3>
          <p class="fs-sm text-light opacity-70 mb-0">{{ 'home.diff1Body' | transloco }}</p>
        </div>
      </div>
      <div class="d-flex pb-4 pb-md-5 mb-2"><i class="fi-search lead text-primary mt-1 order-md-2"></i>
        <div class="text-md-end ps-3 ps-md-0 pe-md-3 order-md-1">
          <h3 class="h6 text-light mb-1">{{ 'home.diff2Title' | transloco }}</h3>
          <p class="fs-sm text-light opacity-70 mb-0">{{ 'home.diff2Body' | transloco }}</p>
        </div>
      </div>
      <div class="d-flex pb-4 pb-md-5 mb-2"><i class="fi-settings lead text-primary mt-1 order-md-2"></i>
        <div class="text-md-end ps-3 ps-md-0 pe-md-3 order-md-1">
          <h3 class="h6 text-light mb-1">{{ 'home.diff3Title' | transloco }}</h3>
          <p class="fs-sm text-light opacity-70 mb-0">{{ 'home.diff3Body' | transloco }}</p>
        </div>
      </div>
    </div>
    <div class="col-md-2 d-none d-md-block">
      <div class="position-relative mx-auto h-100" style="max-width: 5rem; min-height: 26rem;">
        <div class="rellax content-overlay pt-5" data-rellax-percentage="0.5"><img class="pt-3 mt-5 img-fluid" src="assets/img/car-finder/home/carro_cima.png" [alt]="'home.carAlt' | transloco"></div>
        <div class="position-absolute top-0 start-50 translate-middle-x h-100 overflow-hidden"><img src="assets/img/car-finder/home/road-line.svg" width="2" [alt]="'home.roadAlt' | transloco"></div>
      </div>
    </div>
    <div class="col-md-5 col-lg-4 pt-md-5 mt-md-3">
      <div class="d-flex pb-4 pb-md-5 mb-2"><i class="fi-info-circle lead text-primary mt-1"></i>
        <div class="ps-3">
          <h3 class="h6 text-light mb-1">{{ 'home.diff4Title' | transloco }}</h3>
          <p class="fs-sm text-light opacity-70 mb-0">{{ 'home.diff4Body' | transloco }}</p>
        </div>
      </div>
      <div class="d-flex pb-4 pb-md-5 mb-2"><i class="fi-users lead text-primary mt-1"></i>
        <div class="ps-3">
          <h3 class="h6 text-light mb-1">{{ 'home.diff5Title' | transloco }}</h3>
          <p class="fs-sm text-light opacity-70 mb-0">{{ 'home.diff5Body' | transloco }}</p>
        </div>
      </div>
      <div class="d-flex pb-4 pb-md-5 mb-2"><i class="fi-calculator lead text-primary mt-1"></i>
        <div class="ps-3">
          <h3 class="h6 text-light mb-1">{{ 'home.diff6Title' | transloco }}</h3>
          <p class="fs-sm text-light opacity-70 mb-0">{{ 'home.diff6Body' | transloco }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Categorias (home: aluguel em carrossel) / ícones (seminovos) -->
<section class="home-popular-categories" [class.home-aluguel-section]="showReservationFrame" [class.container]="!showReservationFrame" [class.pb-5]="!showReservationFrame" [class.mb-md-4]="!showReservationFrame">
  <div [class.container]="showReservationFrame">
  <div class="mb-3 mb-sm-4 pb-sm-2 d-flex flex-wrap align-items-center justify-content-between gap-2">
    <h2 class="h3 text-light mb-0">{{ homeTipoLocacao === 'assinatura' ? ('home.carrosAssinatura' | transloco) : (showReservationFrame ? ('catalog.aluguel' | transloco) : ('home.categoriasPopulares' | transloco)) }}</h2>
    @if (showReservationFrame) {
      <a class="btn btn-outline-light btn-sm" [routerLink]="locale.localizePath(homeTipoLocacao === 'assinatura' ? '/catalog/list/assinatura' : (homeTipoLocacao === 'tercerizacao' ? '/catalog/list/tercerizacao' : '/catalog/list/aluguel'))">{{ 'common.viewAll' | transloco }}</a>
    }
  </div>
  @if (showReservationFrame) {
    @if (homeAluguelLoading) {
      <p class="text-light opacity-70 small mb-0">{{ 'home.loadingRentals' | transloco }}</p>
    } @else if (homeAluguelCards.length === 0) {
      <p class="text-light opacity-70 small mb-0">
        {{ 'home.noRentals' | transloco: { type: rentalEmptyType() } }}
      </p>
    } @else {
      <div class="home-aluguel-carousel">
      <ngx-slick-carousel class="carousel slickSwiper home-aluguel-carousel__slider" [config]="LatestCar">
        @for (c of homeAluguelCards; track c.id) {
        <div class="swiper-slide" ngxSlickItem>
          <div class="card card-light card-hover home-card-tint home-aluguel-card h-100 d-flex flex-column">
            <div class="card-img-top card-img-hover position-relative">
              <a class="img-overlay" [routerLink]="rotaDetalheAluguel(c)" (click)="selecionarAluguel(c)"></a>
              <img [src]="c.image[0]?.img" [alt]="c.title" class="vehicle-card-image-fixed">
            </div>
            <div class="card-body d-flex flex-column flex-grow-1">
              @if (c.grupoCodigo || c.btn) {
                <div class="home-aluguel-grupo text-primary fw-bold text-uppercase mb-2">
                  @if (c.grupoCodigo) { {{ 'common.group' | transloco }} {{ c.grupoCodigo }} — }
                  {{ c.btn }}
                </div>
              }
              <h3 class="h6 mb-2 home-aluguel-card-title"><a class="nav-link-light" [routerLink]="rotaDetalheAluguel(c)" (click)="selecionarAluguel(c)">{{ c.title }}</a></h3>
              @if (c.descricao) {
                <p class="fs-sm text-light opacity-70 mb-3 home-aluguel-card-desc">{{ c.descricao }}</p>
              }
              <div class="home-aluguel-card-meta mt-auto">
                @if (c.precoNumero != null) {
                  <div class="text-primary fw-bold home-aluguel-price">R$ {{ c.price }}<span class="fs-sm fw-normal text-light opacity-80"> {{ precoMensalCard() ? ('common.perMonth' | transloco) : ('common.perDay' | transloco) }}</span></div>
                } @else if (!auth.isLoggedIn()) {
                  <button type="button" class="btn btn-outline-primary btn-sm" (click)="irParaLogin()"><i class="fi-lock me-1"></i>{{ 'common.seePrice' | transloco }}</button>
                } @else {
                  <p class="fs-sm text-light opacity-70 mb-0">
                    {{ precoMensalCard() ? ('home.monthlyUnavailable' | transloco) : ('home.dailyUnavailable' | transloco) }}
                  </p>
                }
                @if ((configuracao.exibirVendedorELocalizacao$ | async) && c.country) {
                  <div class="fs-sm text-light opacity-70 pt-2"><i class="fi-map-pin me-1"></i>{{ c.country }}</div>
                }
              </div>
            </div>
            <div class="card-footer bg-transparent border-0 pt-0 home-aluguel-card-footer">
              @if (precoMensalCard()) {
                <div class="row g-2 border-top border-light pt-3 mb-3">
                  <div class="col-6">
                    <div class="bg-dark rounded text-center w-100 h-100 p-2">
                      <i class="fi-gearbox d-block h4 text-light mb-0 mx-center"></i>
                      <span class="fs-xs text-light">{{ c.eng }}</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="bg-dark rounded text-center w-100 h-100 p-2">
                      <i class="fi-petrol d-block h4 text-light mb-0 mx-center"></i>
                      <span class="fs-xs text-light">{{ c.fuel }}</span>
                    </div>
                  </div>
                </div>
              }
              <a class="btn btn-primary btn-sm w-100" [routerLink]="rotaDetalheAluguel(c)" (click)="selecionarAluguel(c)">{{ 'common.seeDetails' | transloco }}</a>
            </div>
          </div>
        </div>
        }
      </ngx-slick-carousel>
      </div>
    }
  } @else {
  <div class="popular-categories">
    @for(data of popularData; track data.slug){
    <div class="popular-categories__item">
      <div class="card card-body card-light card-hover bg-transparent border-0 px-0 pt-0 text-center"><img class="d-block mx-auto mb-3" src="{{data.image}}" [alt]="('body.' + data.slug) | transloco"><a class="nav-link-light stretched-link fw-bold" [routerLink]="locale.localizePath('/catalog/list')" [queryParams]="{ tipos: data.slug }">{{ ('body.' + data.slug) | transloco }}</a></div>
    </div>
    }
  </div>
  }
  </div>
</section>

@if (showReservationFrame) {
<section class="cotacao-section pb-5 mb-md-4">
  <div class="container">
    <app-cotacao-form tituloKey="catalog.quoteRental" origem="home-locacao"></app-cotacao-form>
  </div>
</section>
}

@if (showFeaturedOffers) {
<!-- Ofertas em destaque (dados: GET /api/v1/catalogo/venda?destaque=1&per_page=3) -->
<section class="container pt-sm-1 pb-5 mb-md-4">
  <div class="d-sm-flex align-items-center justify-content-between mb-4 pb-sm-2">
    <h2 class="h3 text-light mb-2 mb-sm-0">{{ 'home.featured' | transloco }}</h2>
    <a class="btn btn-link btn-light fw-normal px-0" [routerLink]="locale.localizePath('/catalog/list')">{{ 'home.seeAllOffers' | transloco }}<i class="fi-arrow-long-right fs-sm mt-0 ps-1 ms-2"></i></a>
  </div>
  @if (featuredLoading) {
    <p class="text-light opacity-70 small mb-0">{{ 'home.loadingFeatured' | transloco }}</p>
  } @else if (featuredOfferCards.length === 0) {
    <p class="text-light opacity-70 small mb-0">{{ 'home.noFeatured' | transloco }}</p>
  } @else {
  <div class="row">
    @if (featuredOfferCards[0]; as hero) {
    <div class="col-lg-6">
      <div class="card card-light card-hover h-lg-100 mb-4 mb-lg-0">
        <div class="tns-carousel-wrapper card-img-top card-img-hover">
          <a class="img-overlay" [routerLink]="linkVenda(hero.id)" (click)="selecionarDestaque(hero)"></a>
          <div class="position-absolute start-0 top-0 pt-3 ps-3 zindex-1">
            <span class="d-table badge bg-info mb-1">{{ hero.verified_btn }}</span>
            @if (hero.btn) {
              <span class="d-table badge bg-success">{{ hero.btn }}</span>
            }
          </div>
          <ngx-slick-carousel class="carousel" [config]="Siderconfig">
            @for (slide of hero.image; track $index) {
            <div class="slide" ngxSlickItem>
              <img [src]="slide.img" [alt]="hero.title" class="w-100 object-fit-cover featured-offers-hero-image">
            </div>
            }
          </ngx-slick-carousel>
        </div>
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between pb-1">
            <span class="fs-sm text-light me-3">{{ hero.year }}</span>
            <div class="form-check form-check-light">
              <input class="form-check-input" type="checkbox" [id]="'dest-compare-0'">
              <label class="form-check-label fs-sm" [for]="'dest-compare-0'">{{ 'common.compare' | transloco }}</label>
            </div>
          </div>
          <h3 class="h6 mb-1"><a class="nav-link-light" [routerLink]="linkVenda(hero.id)" (click)="selecionarDestaque(hero)">{{ hero.title }}</a></h3>
          @if (hero.precoNumero != null) {
            <div class="text-primary fw-bold mb-1">R$ {{ hero.price }}</div>
          } @else if (!auth.isLoggedIn()) {
            <button type="button" class="btn btn-outline-primary btn-sm mb-1" (click)="irParaLogin()"><i class="fi-lock me-1"></i>{{ 'common.seePrice' | transloco }}</button>
          } @else {
            <div class="fs-sm text-light opacity-70 mb-1">{{ 'common.onRequest' | transloco }}</div>
          }
          <div class="fs-sm text-light opacity-70" *ngIf="(configuracao.exibirVendedorELocalizacao$ | async)"><i class="fi-map-pin me-1"></i>{{ hero.country }}</div>
        </div>
        <div class="card-footer border-0 pt-0">
          <div class="border-top border-light pt-3">
            <div class="row g-2">
              <div class="col me-sm-1">
                <div class="bg-dark rounded text-center w-100 h-100 p-2">
                  <i class="fi-dashboard d-block h4 text-light mb-0 mx-center"></i>
                  <span class="fs-xs text-light">{{ hero.avg }}K km</span>
                </div>
              </div>
              <div class="col me-sm-1">
                <div class="bg-dark rounded text-center w-100 h-100 p-2">
                  <i class="fi-gearbox d-block h4 text-light mb-0 mx-center"></i>
                  <span class="fs-xs text-light">{{ hero.eng }}</span>
                </div>
              </div>
              <div class="col">
                <div class="bg-dark rounded text-center w-100 h-100 p-2">
                  <i class="fi-petrol d-block h4 text-light mb-0 mx-center"></i>
                  <span class="fs-xs text-light">{{ hero.fuel }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
    <div class="col-lg-6 featured-offers-stack">
      @for (c of featuredOfferCards; track c.id; let i = $index) {
        @if (i > 0) {
        <div class="card card-light card-hover card-horizontal featured-offers-small-card">
          <div class="tns-carousel-wrapper card-img-top card-img-hover">
            <a class="img-overlay" [routerLink]="linkVenda(c.id)" (click)="selecionarDestaque(c)"></a>
            <div class="position-absolute start-0 top-0 pt-3 ps-3 zindex-1">
              <span class="d-table badge bg-info">{{ c.verified_btn }}</span>
              @if (c.btn) {
                <span class="d-table badge" [ngClass]="c.btn_color || 'bg-success'">{{ c.btn }}</span>
              }
            </div>
            <ngx-slick-carousel class="carousel h-100" [config]="Siderconfig">
              @for (slide of c.image; track $index) {
              <div class="slide" ngxSlickItem>
                <div class="bg-size-cover bg-position-center w-100 h-100 card-img-size featured-offers-small-image" [style.background-image]="'url(' + slide.img + ')'"></div>
              </div>
              }
            </ngx-slick-carousel>
          </div>
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between pb-1">
              <span class="fs-sm text-light me-3">{{ c.year }}</span>
              <div class="form-check form-check-light">
                <input class="form-check-input" type="checkbox" [id]="'dest-compare-x' + c.id">
                <label class="form-check-label fs-sm" [for]="'dest-compare-x' + c.id">{{ 'common.compare' | transloco }}</label>
              </div>
            </div>
            <h3 class="h6 mb-1"><a class="nav-link-light" [routerLink]="linkVenda(c.id)" (click)="selecionarDestaque(c)">{{ c.title }}</a></h3>
            @if (c.precoNumero != null) {
              <div class="text-primary fw-bold mb-1">R$ {{ c.price }}</div>
            } @else if (!auth.isLoggedIn()) {
              <button type="button" class="btn btn-outline-primary btn-sm mb-1" (click)="irParaLogin()"><i class="fi-lock me-1"></i>{{ 'common.seePrice' | transloco }}</button>
            } @else {
              <div class="fs-sm text-light opacity-70 mb-1">{{ 'common.onRequest' | transloco }}</div>
            }
            <div class="fs-sm text-light opacity-70" *ngIf="(configuracao.exibirVendedorELocalizacao$ | async)"><i class="fi-map-pin me-1"></i>{{ c.country }}</div>
            <div class="border-top border-light mt-3 pt-3">
              <div class="row g-2">
                <div class="col me-sm-1">
                  <div class="bg-dark rounded text-center w-100 h-100 p-2">
                    <i class="fi-dashboard d-block h4 text-light mb-0 mx-center"></i>
                    <span class="fs-xs text-light">{{ c.avg }}K km</span>
                  </div>
                </div>
                <div class="col me-sm-1">
                  <div class="bg-dark rounded text-center w-100 h-100 p-2">
                    <i class="fi-gearbox d-block h4 text-light mb-0 mx-center"></i>
                    <span class="fs-xs text-light">{{ c.eng }}</span>
                  </div>
                </div>
                <div class="col">
                  <div class="bg-dark rounded text-center w-100 h-100 p-2">
                    <i class="fi-petrol d-block h4 text-light mb-0 mx-center"></i>
                    <span class="fs-xs text-light">{{ c.fuel }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
      }
    </div>
  </div>
  }
</section>
}

<!-- Carros mais recentes (carousel) ou três razões fixas na home -->
<section class="container pt-sm-5 pt-4 pb-3 home-recent-reasons-section">
  <div class="d-sm-flex align-items-center justify-content-between mb-3 mb-sm-4 pb-2">
    <h2 class="h3 text-light mb-3 mb-sm-0">{{ recentCarouselTitle | transloco }}</h2>
    @if (!fixedRecentReasonsGrid) {
    <div class="d-flex align-items-center">
      <a class="btn btn-link btn-light fw-normal px-0" [routerLink]="locale.localizePath('/catalog/grid')">{{ 'common.viewAll' | transloco }}<i class="fi-arrow-long-right fs-sm mt-0 ps-1 ms-2"></i></a>
    </div>
    }
  </div>
  @if (fixedRecentReasonsGrid) {
  <div class="row row-cols-1 row-cols-lg-3 g-3 g-lg-4 home-recent-reasons-grid">
    @for (data of latestCarData; track $index) {
    <div class="col">
      <div class="card card-light card-hover home-card-tint h-100 d-flex flex-column">
        <div class="card-img-top card-img-hover"><a class="img-overlay" [routerLink]="linkRecente(data)"></a>
          @if (showRecentCarouselImageBadges) {
          <div class="position-absolute start-0 top-0 pt-3 ps-3"><span class="d-table badge bg-info mb-1">{{data.verified_btn}}</span><span class="d-table badge {{data.btn_color}}" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-trigger="hover" data-bs-html="true">{{data.btn}}</span></div>
          }
          <img src="{{data.image}}" [alt]="'home.imageAlt' | transloco" class="vehicle-card-image-fixed">
        </div>
        <div class="card-body d-flex flex-column flex-grow-1">
          <h3 class="h6 mb-2 mb-sm-3"><a class="nav-link-light" [routerLink]="linkRecente(data)">{{ data.titleKey ? (data.titleKey | transloco) : data.title }}</a></h3>
          <p class="fs-sm text-light opacity-70 mb-0 flex-grow-1">{{ data.captionKey ? (data.captionKey | transloco) : data.homeCardCaption }}</p>
        </div>
      </div>
    </div>
    }
  </div>
  } @else {
  <div class="home-recent-carousel">
  <ngx-slick-carousel class="carousel slickSwiper home-recent-carousel__slider" [config]="LatestCar">
    @for(data of latestCarData;track $index){
    <div class="swiper-slide" ngxSlickItem>
      <div class="">
        <div class="card card-light card-hover home-card-tint home-recent-card h-100" [class.d-flex]="simpleRecentCarouselCards" [class.flex-column]="simpleRecentCarouselCards">
          <div class="card-img-top card-img-hover"><a class="img-overlay" [routerLink]="linkRecente(data)" (click)="selecionarRecente(data.id)"></a>
            @if (showRecentCarouselImageBadges) {
            <div class="position-absolute start-0 top-0 pt-3 ps-3"><span class="d-table badge bg-info mb-1">{{data.verified_btn}}</span><span class="d-table badge {{data.btn_color}}" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-trigger="hover" data-bs-html="true">{{data.btn}}</span></div>
            }
            <img src="{{data.image}}" [alt]="'home.imageAlt' | transloco" class="vehicle-card-image-fixed">
          </div>
          @if (simpleRecentCarouselCards) {
          <div class="card-body d-flex flex-column flex-grow-1">
            <h3 class="h6 mb-2 mb-sm-3"><a class="nav-link-light" [routerLink]="linkRecente(data)" (click)="selecionarRecente(data.id)">{{ data.titleKey ? (data.titleKey | transloco) : data.title }}</a></h3>
            <p class="fs-sm text-light opacity-70 mb-0 flex-grow-1">{{ data.captionKey ? (data.captionKey | transloco) : data.homeCardCaption }}</p>
          </div>
          } @else {
          <div class="card-body d-flex flex-column flex-grow-1">
            <div class="d-flex align-items-center justify-content-between pb-2"><span class="fs-sm text-light opacity-70 me-3">{{data.year}}</span>
              <div class="form-check form-check-light mb-0">
                <input class="form-check-input" type="checkbox" [id]="'recent-compare-' + $index">
                <label class="form-check-label fs-sm" [for]="'recent-compare-' + $index">{{ 'common.compare' | transloco }}</label>
              </div>
            </div>
            <h3 class="h6 mb-2 home-recent-card-title"><a class="nav-link-light" [routerLink]="linkRecente(data)" (click)="selecionarRecente(data.id)">{{ data.titleKey ? (data.titleKey | transloco) : data.title }}</a></h3>
            <div class="mt-auto">
              @if (data.precoNumero != null) {
                <div class="text-primary fw-bold home-recent-price">{{data.price}}</div>
              } @else if (!auth.isLoggedIn()) {
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="irParaLogin()"><i class="fi-lock me-1"></i>{{ 'common.seePrice' | transloco }}</button>
              } @else {
                <div class="fs-sm text-light opacity-70">{{ 'common.onRequest' | transloco }}</div>
              }
              <div class="fs-sm text-light opacity-70 pt-2" *ngIf="(configuracao.exibirVendedorELocalizacao$ | async)"><i class="fi-map-pin me-1"></i>{{data.country}}</div>
            </div>
          </div>
          <div class="card-footer bg-transparent border-0 pt-0 home-recent-card-footer">
            <div class="row g-2 border-top border-light pt-3 mb-3">
              <div class="col">
                <div class="bg-dark rounded text-center w-100 h-100 p-2"><i class="fi-dashboard d-block h4 text-light mb-0 mx-center"></i><span class="fs-xs text-light">{{data.avg}}K km</span></div>
              </div>
              <div class="col">
                <div class="bg-dark rounded text-center w-100 h-100 p-2"><i class="fi-gearbox d-block h4 text-light mb-0 mx-center"></i><span class="fs-xs text-light">{{data.eng}}</span></div>
              </div>
              <div class="col">
                <div class="bg-dark rounded text-center w-100 h-100 p-2"><i class="fi-petrol d-block h4 text-light mb-0 mx-center"></i><span class="fs-xs text-light">{{data.fuel}}</span></div>
              </div>
            </div>
            <a class="btn btn-primary btn-sm w-100" [routerLink]="linkRecente(data)" (click)="selecionarRecente(data.id)">{{ 'common.seeDetails' | transloco }}</a>
          </div>
          }
        </div>
      </div>
    </div>
    }
  </ngx-slick-carousel>
  </div>
  }
</section>

<!-- CTA carousel-->
@if (ctaReady && ctaVisivel && ctaSlides.length) {
<section class="container pt-4 pb-5 py-sm-5">
  <ngx-slick-carousel class="carousel home-cta-carousel" [config]="slideConfig">
    @for (slide of ctaSlides; track slide.id) {
    <div class="swiper-slide" ngxSlickItem>
      <div>
        <div class="card card-body p-sm-5 card-light h-100">
          <div class="row align-items-center py-3 py-sm-0">
            @if (slide.estilo === 'produtos') {
            <div class="col-md-4 col-xl-3 mb-4 pb-3 mb-md-0 pb-md-0 text-center text-md-start">
              <h2 class="text-light">{{ slide.titulo }}</h2>
              @if (slide.subtitulo) {
              <p class="fs-lg text-light opacity-70 pb-md-4">{{ slide.subtitulo }}</p>
              }
              @if (slide.botao_texto && beneficioLinkInterno(slide.botao_link)) {
              <a class="btn btn-primary" [routerLink]="ctaHref(slide.botao_link)">{{ slide.botao_texto }}<i class="fi-chevron-right fs-sm ms-2"></i></a>
              } @else if (slide.botao_texto && slide.botao_link) {
              <a class="btn btn-primary" [href]="ctaHref(slide.botao_link)">{{ slide.botao_texto }}<i class="fi-chevron-right fs-sm ms-2"></i></a>
              }
            </div>
            <div class="col-md-8 col-xl-9">
              <div class="row row-cols-2 row-cols-lg-4 gy-4 gx-3 gx-sm-4">
                @for (item of slide.itens; track item.id) {
                @if (beneficioLinkInterno(item.link)) {
                <a class="col text-light text-decoration-none" [routerLink]="ctaHref(item.link)">
                  <img class="d-block mb-2 mx-auto" [src]="cardImagem(item.imagem_path)" width="168" [alt]="item.titulo">
                  <div class="fw-bold text-center pt-1">{{ item.titulo }}</div>
                </a>
                } @else if (item.link) {
                <a class="col text-light text-decoration-none" [href]="ctaHref(item.link)">
                  <img class="d-block mb-2 mx-auto" [src]="cardImagem(item.imagem_path)" width="168" [alt]="item.titulo">
                  <div class="fw-bold text-center pt-1">{{ item.titulo }}</div>
                </a>
                } @else {
                <a class="col text-light text-decoration-none" href="javascript:void(0);">
                  <img class="d-block mb-2 mx-auto" [src]="cardImagem(item.imagem_path)" width="168" [alt]="item.titulo">
                  <div class="fw-bold text-center pt-1">{{ item.titulo }}</div>
                </a>
                }
                }
              </div>
            </div>
            } @else {
            <div class="col-md-6 mb-4 pb-3 mb-md-0 pb-md-0 text-center text-md-start">
              <h2 class="text-light">{{ slide.titulo }}</h2>
              @if (slide.subtitulo) {
              <p class="fs-lg text-light opacity-70 pb-md-4">{{ slide.subtitulo }}</p>
              }
              @if (slide.botao_texto && beneficioLinkInterno(slide.botao_link)) {
              <a class="btn btn-primary" [routerLink]="ctaHref(slide.botao_link)">{{ slide.botao_texto }}<i class="fi-chevron-right fs-sm ms-2"></i></a>
              } @else if (slide.botao_texto && slide.botao_link) {
              <a class="btn btn-primary" [href]="ctaHref(slide.botao_link)">{{ slide.botao_texto }}<i class="fi-chevron-right fs-sm ms-2"></i></a>
              }
            </div>
            <div class="col-md-6">
              <div class="row row-cols-sm-3 row-cols-md-2 row-cols-lg-3 gy-4 gx-3 gx-sm-4">
                @for (item of slide.itens; track item.id) {
                <div class="col">
                  @if (beneficioLinkInterno(item.link)) {
                  <a class="text-light text-decoration-none" [routerLink]="ctaHref(item.link)">
                    <div class="d-table bg-dark rounded-3 p-4 mx-auto mb-3"><img class="d-block m-sm-2" [src]="cardImagem(item.imagem_path)" width="56" [alt]="item.titulo"></div>
                    <div class="fw-bold text-center">{{ item.titulo }}</div>
                  </a>
                  } @else if (item.link) {
                  <a class="text-light text-decoration-none" [href]="ctaHref(item.link)">
                    <div class="d-table bg-dark rounded-3 p-4 mx-auto mb-3"><img class="d-block m-sm-2" [src]="cardImagem(item.imagem_path)" width="56" [alt]="item.titulo"></div>
                    <div class="fw-bold text-center">{{ item.titulo }}</div>
                  </a>
                  } @else {
                  <div class="d-table bg-dark rounded-3 p-4 mx-auto mb-3"><img class="d-block m-sm-2" [src]="cardImagem(item.imagem_path)" width="56" [alt]="item.titulo"></div>
                  <div class="fw-bold text-center">{{ item.titulo }}</div>
                  }
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    }
  </ngx-slick-carousel>
</section>
}

<!-- Últimas notícias -->
<section class="container pb-4 pb-sm-5 mb-2 mb-md-4">
  <div class="d-sm-flex align-items-center justify-content-between mb-3 mb-sm-4 pb-sm-2">
    <h2 class="h3 text-light mb-2 mb-sm-0">{{ 'home.latestNews' | transloco }}</h2><a class="btn btn-link btn-light fw-normal px-0" [routerLink]="locale.localizePath('/noticias')">{{ 'home.goToNews' | transloco }}<i class="fi-arrow-long-right fs-sm mt-0 ps-1 ms-2"></i></a>
  </div>
  <ngx-slick-carousel class="carousel mb-5 custom-swiper pagination-hide" [config]="LatestCar">
    @for(data of newsData;track $index){
    <div class="swiper-slide pe-3" ngxSlickItem>
      <div>
        <article><a class="noticia-card-frame d-block rounded-3" [routerLink]="noticiaLink(data)"><img [src]="data.imageCard || data.image" [alt]="data.title"></a>
          <div class="py-3"><span class="fs-xs text-uppercase text-decoration-none">{{data.sub_title}}</span>
            <h3 class="text-light fs-base pt-1"><a class="nav-link" [routerLink]="noticiaLink(data)">{{ data.title }}</a>
            </h3>
            <div class="d-flex align-items-center text-decoration-none mt-2">
              <div class="ps-0">
                <h6 class="fs-sm text-light lh-base mb-1">{{ data.name || ('common.newsroom' | transloco) }}</h6>
                <div class="d-flex fs-xs text-light opacity-60"><span class="me-2 pe-1"><i class="fi-calendar-alt me-1"></i>{{data.date}}</span><span><i class="fi-chat-circle me-1"></i>{{data.comments}}</span></div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
    }
  </ngx-slick-carousel>
</section>

<!-- Footer-->
<app-footer></app-footer>
